/**
 * src/components/ui/NotaAccion.jsx
 * El pie de texto de un botón de acción del panel admin.
 *
 * Pedido por Manuel (29-08). El panel ha ganado en pocos días media docena de
 * botones —censar convenios, sondear los sin mapear, revalidar el survey, medir
 * fichas— que **solo sabe pulsar quien los construyó**: ni el rótulo dice qué
 * hacen, ni cuánto tardan, ni qué hay que mirar en el resultado.
 *
 * Las tres cosas van juntas a propósito, porque son las tres que hacen falta
 * para decidirse a pulsar: `qué` (para qué sirve), `coste` (si va a tardar dos
 * minutos, se avisa ANTES y no después) y `mirar` (qué significa lo que sale —
 * sin eso, una tabla de veredictos obliga a preguntar).
 *
 * 📌 Y es el germen del manual de onboarding del §6.6 del ESTADO: la explicación
 * vive junto al botón, no en un documento aparte que se queda viejo el día que
 * alguien cambia el botón.
 */

export function NotaAccion({ que, coste, mirar }) {
  return (
    <div style={{
      marginTop: 'var(--space-2)', maxWidth: '78ch',
      fontSize: 'var(--text-xs)', lineHeight: 1.6,
      color: 'var(--color-text-3)',
    }}>
      <div>{que}</div>
      {coste && (
        <div style={{ marginTop: 'var(--space-05)' }}>
          <span style={{ fontFamily: 'var(--font-mono)' }}>Tarda:</span> {coste}
        </div>
      )}
      {mirar && (
        <div style={{ marginTop: 'var(--space-05)' }}>
          <span style={{ fontFamily: 'var(--font-mono)' }}>Qué mirar:</span> {mirar}
        </div>
      )}
    </div>
  )
}
